export default "__VITE_ASSET__Z9qyPxm0__"